import { errorHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { mapReference } from 'modules/data/domain/schemas';
import { AsyncDataProvider } from 'modules/data-providers';
import { useSelector } from 'modules/react-redux';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { getRequestEditMode } from 'pages/requestForm/selectors/requestSelectors';
import { getRuleTypeByEditMode } from 'pages/requestForm/utils/helpers';
import { FC, PropsWithChildren, useCallback } from 'react';
import { useLazyGetNetSuitePayees } from 'shared/data/webApp/v1';

export const NetSuitePayeesDataProvider: FC<PropsWithChildren> = (props) => {
    const { children } = props;

    const request = useSelector(requestSelector);
    const editMode = useSelector((state) => getRequestEditMode(state, request));
    const ruleType = getRuleTypeByEditMode(editMode);

    const { id: requestId, companyId } = request;

    const [getNetSuitePayees] = useLazyGetNetSuitePayees();

    const onLoad = useCallback(
        async (filterText: string | null, startFrom: number, count: number): Promise<domain.NetSuitePayee[]> => {
            try {
                const response = await getNetSuitePayees({
                    params: {
                        query: {
                            requestId,
                            ruleType,
                            query: filterText,
                            startFrom,
                            rowNum: count,
                            companyId,
                        },
                    },
                });

                return response.values.map((item) => ({
                    ...item,
                    text: item.name,
                    defaultPayablesAccount: mapReference(item.defaultPayablesAccount),
                }));
            } catch (error) {
                errorHelpers.captureException(error);
            }

            return [];
        },
        [requestId, companyId, ruleType, getNetSuitePayees]
    );

    return (
        <AsyncDataProvider cacheStorageId={`requestOptions.netSuitePayees.${requestId}`} pageSize={100} onLoad={onLoad}>
            {children}
        </AsyncDataProvider>
    );
};

NetSuitePayeesDataProvider.displayName = 'NetSuitePayeesDataProvider';
